import { gql } from '@apollo/client';

export const SERVICE_PROVIDER = gql`
  fragment serviceProvider on ServiceProvider {
    id
    name
    isArchived
    # enums
    legalStructure
    roles
    type

    # scalars
    address
    contactNumber
    description
    email
    execInCharge
    firstContactPerson
    firstContactPersonEmail
    firstContactPersonNumber
    idNum
    designation
    logo
    name
    orgLeader
    orgLeaderDesignation
    orgLeaderNumber
    orgLeaderPersonEmail
    physicalAddress
    registrationNumber
    secondContactPerson
    secondContactPersonEmail
    secondContactPersonNumber
    title
    website
  }
`;
